import { formatDenominatedNumber } from 'helpers/mvx/formatters';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import BigNumber from 'bignumber.js';

export const ComputedDistributionData = () => {
  const rewardDistribution = useSelector(
    (state: RootState) => state.rawVesta.rewardDistributionData
  );
  return (
    <div className='accordion-item' style={{ borderRadius: '0.625rem' }}>
      <h2 className='accordion-header' id='headingTwo'>
        <button
          className='accordion-button text-center'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseTwo'
          aria-expanded='true'
          aria-controls='collapseTwo'
        >
          Show Computed Distribution Data
        </button>
      </h2>
      <div
        id='collapseTwo'
        className='accordion-collapse collapse'
        aria-labelledby='headingTwo'
        data-bs-parent='#accordionExampleTwo'
      >
        <div className='accordion-body'>
          <div className='table-responsive'>
            <table className='table'>
              <thead>
                <tr>
                  <th scope='col'>Address</th>
                  <th scope='col'>Raw VST airdropped</th>
                </tr>
              </thead>
              <tbody>
                {rewardDistribution.data?.computedRewardDistributionData?.map(
                  (data, index) => (
                    <tr key={`aggregated-reward-data-entry-${index}`}>
                      <th>{data.address}</th>
                      <td>{formatDenominatedNumber(data.amount)}</td>
                    </tr>
                  )
                )}
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <td>
                    {formatDenominatedNumber(
                      (
                        rewardDistribution.data
                          ?.computedRewardDistributionData ?? []
                      )
                        .reduce(
                          (prev, crt) =>
                            (prev = prev.plus(new BigNumber(crt.amount))),
                          new BigNumber(0)
                        )
                        .toString()
                    )}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
